import { render, staticRenderFns } from "./ConsignmentList.vue?vue&type=template&id=7a3756b0"
import script from "./ConsignmentList.vue?vue&type=script&lang=js"
export * from "./ConsignmentList.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentList.vue?vue&type=style&index=0&id=7a3756b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports